import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import './css/Obituaries.styl';
import Obituary from './obituary';
import MobileAdUnit from './MobileAdUnit';
import {buildFuneralHomeFlowersUrl} from '../../../../../shared/utilities/urlHelpers';
import {getGATags} from '../../../../../shared/utilities/GAHelpers';
import {getMoreObituaries} from '../../../../../redux/obituariesHelper';
import Header from '../../../../../shared/library/Header/Header';
import FlowersAd from '../../Shared/FlowersAd';
import imageFlower1 from '../../Shared/FlowersAd/assets/flower1.jpg';
import imageFlower2 from '../../Shared/FlowersAd/assets/flower2.jpg';
import imageFlower3 from '../../Shared/FlowersAd/assets/flower3.jpg';
import SearchObituaries from '../../Shared/SearchObituaries/SearchObituaries';
import _get from 'lodash/get';
import Spinner from '../../../../../shared/library/Spinner/Spinner';
import {AdService} from 'legacy-advertising';

export class Obituaries extends Component {
  static propTypes = {
    adService: PropTypes.shape({type: PropTypes.instanceOf(AdService)})
      .isRequired,
  };

  state = {
    isMobile: this.props.isMobile,
  };

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  ticking = false;
  lastScrollPos = 0;

  getScrollPos = () => {
    const supportPageOffset = window.pageXOffset !== undefined; // eslint-disable-line no-undefined
    const isCSS1Compat = (document.compatMode || '') === 'CSS1Compat';

    if (supportPageOffset) {
      return window.pageYOffset;
    }

    return isCSS1Compat
      ? document.documentElement.scrollTop
      : document.body.scrollTop;
  };

  handleScroll = () => {
    const {obituaries} = this.props;
    const {loading, showLoadMoreButton} = obituaries;
    let direction = '';

    if (this.getScrollPos() > this.lastScrollPos) {
      direction = 'down';
    } else {
      direction = 'up';
    }

    this.lastScrollPos = this.getScrollPos();

    if (!this.ticking && !loading && showLoadMoreButton) {
      const tabHeight = this.tabRef.clientHeight;
      const threshold = Math.ceil(tabHeight * 0.85);

      window.requestAnimationFrame(() => {
        if (direction === 'down' && this.lastScrollPos >= threshold) {
          this.handleInfiniteScroll();
        }
        this.ticking = false;
      });

      this.ticking = true;
    }
  };

  handleSendFlowersClick = () => {
    getGATags({
      eventCategory: 'fhd_flowers',
      eventAction: 'fhd_flowers_click',
      eventLabel: 'fhd_flowers_store',
    });
  };

  handleInfiniteScroll = () => {
    const {funeralHome, affiliateId, dispatch} = this.props;
    const funeralHomeId = funeralHome.funeralHomeId;

    getGATags({
      eventCategory: 'fhd_obitload',
      eventAction: 'fhd_obitload_click',
      eventLabel: 'fhd_obitload_loadmore',
    });

    dispatch(getMoreObituaries(funeralHomeId, affiliateId));
  };

  shouldRenderObituaries() {
    return (
      this.props.obituaries &&
      this.props.obituaries.people &&
      this.props.obituaries.people.length
    );
  }

  renderAds(index) {
    const {adService} = this.props;
    const {isMobile} = this.state;
    let positionId = null;

    if (!isMobile || index <= 10) {
      return null;
    }

    if (index % 10 === 4) {
      positionId = `custom-inline-1`;
    }

    if (index % 10 === 9) {
      positionId = `custom-inline-2`;
    }

    if (positionId) {
      this.adCount++;
      const slotName = `inlineAd${this.adCount}`;
      const slotKeyValues = [{key: 'spot', value: this.adCount.toString()}];

      return (
        <div style={{margin: '1.5rem 0', textAlign: 'center'}}>
          <MobileAdUnit
            adService={adService}
            positionId={positionId}
            slotName={slotName}
            slotKeyValues={slotKeyValues}
          />
        </div>
      );
    }
    return null;
  }

  renderRecentObituariesWithFlowersAd(flowersUrlOptions) {
    const flowersAdsItems = [
      {
        image: imageFlower1,
        text: 'The FTD® Comfort™ Planter',
        link: buildFuneralHomeFlowersUrl(flowersUrlOptions),
      },
      {
        image: imageFlower2,
        text: 'The FTD® Faithful Blessings™ Bouquet - VASE INCLUDED',
        link: buildFuneralHomeFlowersUrl(flowersUrlOptions),
      },
      {
        image: imageFlower3,
        text: 'The FTD® Eternal Affection™ Arrangement',
        link: buildFuneralHomeFlowersUrl(flowersUrlOptions),
      },
    ];

    const obituaries = this.props.obituaries;
    const flowersAd = this.props.planning ? null : (
      <FlowersAd
        key={'flowersAd'}
        flowersAdItems={flowersAdsItems}
        flowersUrlOptions={flowersUrlOptions}
      />
    );
    const flowerAdIndex = obituaries.people.length <= 5 ? -1 : 5;

    this.adCount = 0;

    return (
      <div>
        {obituaries.people.map((person, index) => (
          <div key={person.personId} style={{marginBottom: '1.5rem'}}>
            {index === flowerAdIndex && flowersAd}
            {this.renderAds(index)}
            <Obituary person={person} />
          </div>
        ))}
        {this.props.obituaries.isLoading && (
          <div style={{marginTop: 40}}>
            <Spinner size={60} />
          </div>
        )}
        {flowerAdIndex === -1 && flowersAd}
      </div>
    );
  }

  renderRecentObituaries(flowersUrlOptions) {
    return (
      <div className="obituaries-collection">
        <Header type={'no-border'} title="Recent Obituaries" />
        {this.renderRecentObituariesWithFlowersAd(flowersUrlOptions)}
      </div>
    );
  }

  renderNoRecentObituaries() {
    return (
      <div className="obituaries-collection">
        <Header type={'no-border'} title="Recent Obituaries" />
        <p>
          There are no recent obituaries at this time. Search for older
          obituaries.
        </p>
      </div>
    );
  }

  render() {
    const {affiliateId, funeralHome, isMobile} = this.props;
    const {funeralHomeId, name, location, flowerSettings} = funeralHome;
    const flowersUrlOptions = {
      funeralHomeId,
      funeralHomeName: name,
      affiliateId,
      cultureCode: location.country.cultureCode,
      flowerSettings,
      isMobile,
    };

    return (
      <div
        className="obituaries-tab"
        ref={element => {
          this.tabRef = element;
        }}
      >
        <Header title="Attending The Funeral" />
        <div className="tab-overview">
          <p>
            We encourage you to contact the funeral home to verify time and
            location before attending services or visitation.
          </p>
          <p>
            To send flowers to {this.props.funeralHome.name} please visit our{' '}
            <a
              href={buildFuneralHomeFlowersUrl(flowersUrlOptions)}
              className="link-send-flowers"
              data-ga-no-auto-tag
              onClick={this.handleSendFlowersClick}
            >
              sympathy store
            </a>
            .
          </p>
        </div>
        {this.shouldRenderObituaries()
          ? this.renderRecentObituaries(flowersUrlOptions)
          : this.renderNoRecentObituaries()}
        <div className="obituaries__search-obituaries">
          <Header type={'no-border'} title="Search Obituaries" />
          <SearchObituaries />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  funeralHome: state.funeralHomeStore,
  obituaries: state.obituaryStore,
  affiliateId: state.affiliateStore.sourceId,
  planning: _get(state, 'planningStore.isPlanning'),
  isMobile: state.mobileDetailsStore.any,
  adService: state.adStore.adService,
});

export default connect(mapStateToProps)(Obituaries);



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/Tabs/Obituaries/index.js